export const tableHeader = (t) => [
  {
    id: 'name',
    type: 'text',
    value: t('processes.table.name'),
  },
  {
    id: 'criticity',
    type: 'select',
    value: t('processes.table.criticality'),
    render: (value, item) => {
      const criticity = value || item?.criticity;
      if (!criticity) return '-';

      const getCriticityColor = (level) => {
        const colors = {
          '1': '#22c55e',
          '2': '#84cc16',
          '3': '#eab308',
          '4': '#f97316',
          '5': '#ef4444'
        };
        return colors[level] || '#6b7280';
      };

      const getCriticityLabel = (level) => t(`processes.criticality.${level}`, level);

      return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <div
            style={{
              width: '12px',
              height: '12px',
              borderRadius: '50%',
              backgroundColor: getCriticityColor(criticity),
              border: '1px solid rgba(0,0,0,0.1)'
            }}
          />
          <span>{getCriticityLabel(criticity)}</span>
        </div>
      );
    }
  },
  {
    id: 'description',
    type: 'text',
    value: t('processes.list.filters.description'),
  },
  {
    id: 'user',
    type: 'text',
    value: t('processes.table.responsible'),
  },
  {
    id: 'dpia',
    type: 'boolean',
    value: t('processes.table.dpia'),
  },
  {
    id: 'lia',
    type: 'boolean',
    value: t('processes.table.lia'),
  },
  {
    id: 'action',
    type: 'actions',
    value: '',
    minWidth: '140px'
  },
];
